/* eslint-disable */
export default {
  download: '下载',
  play: '播放',
  pause: '暂停',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
